// Comptes de présentation : liste des comptes fictifs lisibles par la page de connexion, hors
// production seulement (HD-02, R20). Les valeurs viennent de docs/realisation/comptes-presentation.md.
import { z } from 'zod';

export const schemaComptePresentation = z.object({
  identifiant: z.string(),
  profil: z.string(),
  roles: z.string().nullable(),
  mot_de_passe: z.string(),
  /** Second facteur préconfiguré : le code courant est servi par /public/comptes-presentation/:identifiant/code. */
  mfa: z.boolean(),
});
export type ComptePresentation = z.infer<typeof schemaComptePresentation>;

export const schemaGroupeComptesPresentation = z.object({
  /** Titre du groupe, par exemple « Commune de Mbeng-Ntem ». */
  titre: z.string(),
  code: z.string().nullable(),
  comptes: z.array(schemaComptePresentation),
});
export type GroupeComptesPresentation = z.infer<typeof schemaGroupeComptesPresentation>;

export const schemaComptesPresentation = z.object({
  environnement: z.string(),
  groupes: z.array(schemaGroupeComptesPresentation),
});
export type ComptesPresentation = z.infer<typeof schemaComptesPresentation>;

export const schemaCodePresentation = z.object({
  identifiant: z.string(),
  code: z.string().regex(/^\d{6}$/),
  /** Secondes restantes avant le code suivant. */
  valide_pendant_secondes: z.number().int().min(0).max(30),
});
export type CodePresentation = z.infer<typeof schemaCodePresentation>;
